import { AUTH_TOKEN } from '@tools/ui/consts';

export const getAuthToken = (): string => {
  const token = localStorage.getItem(AUTH_TOKEN);
  return token || '';
};
